import { URLS } from '../constants'
import {
    REGISTER_BEGIN, REGISTER_SUCCESS, REGISTER_FAILURE,
    LOGIN_BEGIN, LOGIN_FAILURE, LOGIN_SUCCESS,
    VERIFY_AUTH_COOKIE_BEGIN, VERIFY_AUTH_COOKIE_SUCCESS, VERIFY_AUTH_COOKIE_FAILURE,
    RECONNECT_BEGIN, RECONNECT_SUCCESS, RECONNECT_FAILURE,
    SET_DISCONNECT,
    LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_FAILURE,
    SET_DARK_MODE,
    GET_ALL_ACCESS_CREDENTIALS_BEGIN, GET_ALL_ACCESS_CREDENTIALS_SUCCESS, GET_ALL_ACCESS_CREDENTIALS_FAILURE,
} from '../constants/ActionTypes'

import { dispatchFetchPost, dispatchFetchGet } from './ActionUtil'


// Register
const acPostRegisterBegin = () => ({ type: REGISTER_BEGIN })
const acPostRegisterSuccess = data => ({ type: REGISTER_SUCCESS, payload: data })
const acPostRegisterFailure = err => ({ type: REGISTER_FAILURE, payload: err })

/**
 * Function to register a user.
 *
 * @param {Object} params - The parameters for registration.
 * @param {string} params.email - The email of the user.
 * @param {string} params.cnpj - The CNPJ of the user.
 * @returns {Promise} - A promise that resolves to the result of the registration.
 */
export const acPostRegister = ({ email, cnpj }) => {
    return dispatchFetchPost(
        URLS.REGISTER,
        { email, cnpj },
        acPostRegisterBegin,
        acPostRegisterSuccess,
        acPostRegisterFailure
    )
}

// Login
const acPostLoginBegin = () => ({ type: LOGIN_BEGIN })
const acPostLoginSuccess = data => ({ type: LOGIN_SUCCESS, payload: data })
const acPostLoginFailure = err => ({ type: LOGIN_FAILURE, payload: err })

/**
 * @description Function to perform a login request.
 *
 * @author Maria Eduarda Franke
 */
export const acPostLogin = ({ email, password }) => {
    return dispatchFetchPost(
        URLS.LOGIN,
        { email, password },
        acPostLoginBegin,
        acPostLoginSuccess,
        acPostLoginFailure
    )
}

// Verify Auth Cookie
const acVerifyAuthCookieBegin = () => ({ type: VERIFY_AUTH_COOKIE_BEGIN })
const acVerifyAuthCookieSuccess = data => ({ type: VERIFY_AUTH_COOKIE_SUCCESS, payload: data })
const acVerifyAuthCookieFailure = err => ({ type: VERIFY_AUTH_COOKIE_FAILURE, payload: err })

/**
 * Verifies authentication cookie
 *
 * @author Maria Eduarda Franke
 * @returns {Object} The dispatched action object.
 */
export const acVerifyAuthCookie = () => {
    return dispatchFetchGet(
        URLS.VERIFY_AUTH_COOKIE,
        acVerifyAuthCookieBegin,
        acVerifyAuthCookieSuccess,
        acVerifyAuthCookieFailure
    )
}

// Reconnect
const acPostReconnectBegin = () => ({ type: RECONNECT_BEGIN })
const acPostReconnectSuccess = data => ({ type: RECONNECT_SUCCESS, payload: data })
const acPostReconnectFailure = err => ({ type: RECONNECT_FAILURE, payload: err })

/**
 * @description Function to initiate a post request to reconnect.
 *
 * @author Maria Eduarda Franke
 */
export const acPostReconnect = () => {
    return dispatchFetchPost(
        URLS.RECONNECT,
        {},
        acPostReconnectBegin,
        acPostReconnectSuccess,
        acPostReconnectFailure
    )
}

// Disconnect
export const acSetDisconnect = () => ({ type: SET_DISCONNECT })

// Logout
const acPostLogoutBegin = () => ({ type: LOGOUT_BEGIN })
const acPostLogoutSuccess = data => ({ type: LOGOUT_SUCCESS, payload: data })
const acPostLogoutFailure = err => ({ type: LOGOUT_FAILURE, payload: err })

/**
 * Dispatches a fetch POST request to the LOGOUT URL with empty body.
 * 
 * @author Maria Eduarda Franke
 * @returns {Promise} A promise that resolves with the response data if the request is successful, 
 *                    or rejects with an error if the request fails.
 * 
 * @throws {Error} If the request fails.
 */
export const acLogout = () => {
    return dispatchFetchPost(
        URLS.LOGOUT,
        {},
        acPostLogoutBegin,
        acPostLogoutSuccess,
        acPostLogoutFailure
    )
}

/**
 * @description Function to perform color theme change.
 *
 * @author Maria Eduarda Franke
 */
export const acSetDarkMode = data => ({ type: SET_DARK_MODE, payload: data })

// Get All Access Credentials
const acGetAllCompaniesBegin = () => ({ type: GET_ALL_ACCESS_CREDENTIALS_BEGIN })
const acGetAllCompaniesSuccess = data => ({ type: GET_ALL_ACCESS_CREDENTIALS_SUCCESS, payload: data })
const acGetAllCompaniesFailure = err => ({ type: GET_ALL_ACCESS_CREDENTIALS_FAILURE, payload: err })

/**
 * @description Function to get all access credentials.
 * 
 * @author Paulo Victor Borges
 * @returns {Promise} - A promise that resolves to the result of the API call.
 */

export const acGetAllCompanies = () => {
    return dispatchFetchGet(
        URLS.COMPANIES,
        acGetAllCompaniesBegin,
        acGetAllCompaniesSuccess,
        acGetAllCompaniesFailure
    )
}